export const NEW_ERROR = 'NEW_ERROR';

const addError = error => (
  (dispatch) => {
    dispatch({
      type: NEW_ERROR,
      error,
    });
  }
);

export default addError;
